import { render } from "./ProjectsContent.vue?vue&type=template&id=2d401b03&scoped=true"
import script from "./ProjectsContent.vue?vue&type=script&lang=js"
export * from "./ProjectsContent.vue?vue&type=script&lang=js"

import "./ProjectsContent.vue?vue&type=style&index=0&id=2d401b03&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d401b03"]])

export default __exports__